import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, MouseEventHandler } from "react";
import styled from "styled-components";

interface IProps {
  id: string;
  direction: "left" | "right";
  eventHandler: MouseEventHandler<HTMLDivElement>;
}

const Button = styled.div`
  background-color: ${(props) => props.theme.selected};
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  color: ${(props) => props.theme.primary};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HideShowButton: FC<IProps> = ({ eventHandler, direction, id }) => {
  return (
    <Button onClick={eventHandler} id={id}>
      <FontAwesomeIcon
        icon={faChevronLeft}
        className={direction === "left" ? "fa-rotate" : "fa-rotate-180"}
        style={{ transition: "all 0.3s ease-out" }}
      />
    </Button>
  );
};

export default HideShowButton;
